import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel'];

  async connect() {
    const currentTab = this.tabTargets.find((tab) => tab.getAttribute('aria-selected') === 'true');

    if (currentTab) {
      const lib = await import('scroll-into-view-if-needed');
      const scrollIntoView = lib.default;
      scrollIntoView(currentTab, { inline: 'center', boundary: this.element });
    }
  }

  changeTab(event) {
    const selectedTab = event.currentTarget;
    const selectedTabId = selectedTab.getAttribute('aria-controls');

    this.tabTargets.forEach((tab) => {
      const panelId = tab.getAttribute('aria-controls');
      if (panelId === selectedTabId) {
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', 0);
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', -1);
      }
    });

    this.panelTargets.forEach((panel) => {
      const panelId = panel.getAttribute('id');
      if (panelId === selectedTabId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  _getNextTab(currentTab, direction) {
    const currentIndex = this.tabTargets.indexOf(currentTab);
    const nextIndex =
      (this.tabTargets.length +
        (direction === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1)) %
      this.tabTargets.length;

    return this.tabTargets[nextIndex];
  }

  handleKeydown(event) {
    const key = event.key;
    const currentTab = event.currentTarget;

    if (key === 'ArrowRight' || key === 'ArrowLeft') {
      event.preventDefault();
      const nextTab = this._getNextTab(currentTab, key);
      nextTab.focus();
    }
  }
}
